import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, MapPin, CalendarDays } from "lucide-react";
import { ASSETS } from "../../data/assets";
import { EVENT } from "../../data/mockData";

export function Footer() {
  return (
    <footer className="relative bg-sea-deep text-white pt-16 pb-8 mt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="bg-white rounded-3xl p-3 inline-block shadow-playful">
            <img src={ASSETS.logo} alt="BLTR 2026" className="h-16 w-auto" />
          </div>
          <div className="mt-4 space-y-1 text-white/80 font-semibold text-sm">
            <p className="flex items-center gap-2"><CalendarDays className="w-4 h-4" /> {EVENT.dateLabel}</p>
            <p className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {EVENT.venue}</p>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3">Explore</h4>
          <ul className="space-y-2 text-white/80 font-semibold text-sm">
            <li><Link to="/" className="hover:text-lime">Home</Link></li>
            <li><Link to="/tickets" className="hover:text-lime">Tickets</Link></li>
            <li><Link to="/activities" className="hover:text-lime">Activities</Link></li>
            <li><Link to="/faq" className="hover:text-lime">FAQ</Link></li>
            <li><Link to="/my-booking" className="hover:text-lime">My Booking</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3">Info</h4>
          <ul className="space-y-2 text-white/80 font-semibold text-sm">
            <li><Link to="/event-info" className="hover:text-lime">Event Info</Link></li>
            <li><a href="#" className="hover:text-lime">Terms &amp; Conditions</a></li>
            <li><a href="#" className="hover:text-lime">Privacy Policy</a></li>
            <li><a href={`mailto:${EVENT.contactEmail}`} className="hover:text-lime">Contact</a></li>
            <li><Link to="/admin" className="hover:text-lime">Admin</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3">Follow the Fun</h4>
          <div className="flex gap-3">
            <a href="#" aria-label="Instagram" className="w-11 h-11 rounded-full bg-white/10 hover:bg-lime hover:text-sea-deep flex items-center justify-center transition-colors"><Instagram className="w-5 h-5" /></a>
            <a href="#" aria-label="Facebook" className="w-11 h-11 rounded-full bg-white/10 hover:bg-lime hover:text-sea-deep flex items-center justify-center transition-colors"><Facebook className="w-5 h-5" /></a>
            <a href="#" aria-label="Youtube" className="w-11 h-11 rounded-full bg-white/10 hover:bg-lime hover:text-sea-deep flex items-center justify-center transition-colors"><Youtube className="w-5 h-5" /></a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-white/15 text-center">
        <p className="text-white/60 text-xs leading-relaxed max-w-3xl mx-auto">
          Balita® and Baba Lili Tata® are registered trademarks of PT Citra Balita Kirana, used under license. All rights reserved.
        </p>
        <p className="text-white/40 text-xs mt-2">© 2026 {EVENT.name}. Prototype UI.</p>
      </div>
    </footer>
  );
}
